
class CapRunScheduleRequestControlPanelTask {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'run_schedule_request_control_panel_task'
}

function create(config) {
  return new CapRunScheduleRequestControlPanelTask(config)
}

export default {
  key,
  create,
}
